module.exports = __webpack_public_path__ + "static/merch01.50baf523.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/merch01.png
// module id = 503
// module chunks = 114276838955818